import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const emptyStateContainerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing(2)};
  position: absolute;
  z-index: ${theme.zIndex.low};
  width: 100%;
  height: 100%;
  padding: 50px 70px;
  backdrop-filter: blur(2px);
`;
